import { createActions, createReducer } from 'reduxsauce'

import GestoresContratoService from '../../servicos/GestoresContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaGestoresContratoInicio: [],
    buscaGestoresContratoSucesso: ['gestoresContrato'],
    buscaGestoresContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaGestoresContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaGestoresContratoInicio())
        let serv = new GestoresContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaGestoresContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaGestoresContratoErro(error)))
    }
}

const buscaGestoresContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaGestoresContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaGestoresContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.gestoresContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_GESTORES_CONTRATO_INICIO]: buscaGestoresContratoInicio,
    [Types.BUSCA_GESTORES_CONTRATO_ERRO]: buscaGestoresContratoErro,
    [Types.BUSCA_GESTORES_CONTRATO_SUCESSO]: buscaGestoresContratoSucesso,
})
